import { Dialog, DialogContent } from "@mui/material";
import React from "react";
import ViewReverse from "./ViewReverse";
import { fontSizes } from "../constants/constants";
import Text from "./Text";
import Button from "./Button";
import { cn, getContentKeyAccToLang } from "../utils/utils";
import dynamicfunction from "../utils/dynamicfunction";
import { useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import icons from "../constants/icons";

const ConfirmModal = ({ open, onClose, title, description, onConfirm, loading = false, acceptText, isVertical = false, showConfirmIcon = false }) => {
  const { isArabic } = dynamicfunction();
  const { fundsContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_subscribe?.data?.attributes,
      key,
      isArabic
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContent className="p-0 sm:min-w-96">
        {
          showConfirmIcon && (
            <div className="w-full flex justify-center items-center mb-2">
              <ReactSVG src={icons?.tickCircleIcon} />
            </div>
          )
        }
        <Text text={title} size={fontSizes.h20} className={"capitalize"} isCenter />

        <Text text={description} size={fontSizes.h14} className={"mt-4"} isTruncate={false} isCenter color="text-zinc-400" />
        <div className="h-6" />

        <ViewReverse
          className={cn("items-center justify-between rounded bg-white gap-4 mt-2", isVertical && 'flex-col')}
        >
          <Button
            text={getContentKey("cancel")}
            bgColor="bg-white"
            color={"text-primary"}
            className={cn("text-center px-0 border border-primary", isVertical ? 'w-full order-2' : 'w-1/2')}
            onClick={onClose}
            isDisabled={loading}
          />
          <Button
            text={acceptText ?? getContentKey("confirm")}
            bgColor="bg-primary"
            className={cn("text-center max-w-70 px-4", isVertical ? 'w-full order-1' : 'w-1/2')}
            onClick={onConfirm}
            loading={loading}
            isDisabled={loading}
          />
        </ViewReverse>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
